module.exports = __webpack_public_path__ + "img/align_top.6bca540f.svg";